import React from 'react'
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons'

const Arrow = ({ direction, onClick, style }) => {
  const arrowStyle = {
    color: 'white',
    padding: '5px',
    borderRadius: '50%',
    cursor: 'pointer',
    fontSize: '25px',
  }

  return (
    <div style={{ ...arrowStyle, ...style }} onClick={onClick}>
      {direction === 'up' ? <ArrowUpOutlined /> : <ArrowDownOutlined />}
    </div>
  )
}

export default Arrow
